import Integrations from "../../views/integrations/index";
import ZoomIntegration from "../../views/integrations/zoom/index";
import GoogleMeetIntegration from "../../views/integrations/meet/index";
import MicrosoftTeamsIntegration from "../../views/integrations/ms-teams/index";
import StripeIntegration from "../../views/integrations/stripe";
import PaypalIntegration from "../../views/integrations/paypal";

const routes = [
    {
        component: Integrations,
        exact: true,
        path: "/integrations"
    },
    {
        component: ZoomIntegration,
        exact: true,
        path: "/integrations/zoom"
    },
    {
        component: GoogleMeetIntegration,
        exact: true,
        path: "/integrations/meet"
    },
    {
        component: MicrosoftTeamsIntegration,
        exact: true,
        path: "/integrations/ms-teams"
    },
    {
        component: StripeIntegration,
        exact: true,
        path: "/integrations/stripe"
    },
    {
        component: PaypalIntegration,
        exact: true,
        path: "/integrations/paypal"
    },
];

export default routes;